module.exports = __webpack_public_path__ + "img/service-4.39d627ed.jpg";